module.exports = __webpack_public_path__ + "img/bill.3a8faaf3.png";